export const sectionAbbreviation = [
    {
        label: "HUMAN-CENTRED DESIGN",
        value: "HCD"
    },
    {
        label: "ROLES & RESPONSIBILITIES",
        value: "R&R"
    },
    {
        label: "SENSE-MAKING",
        value: "SM"
    },
    {
        label: "COMMUNICATIONS",
        value: "COMM"
    },
    {
        label: "TEAMWORKING",
        value: "TEAMW"
    },
    {
        label: "ERROR AND FAILURE MANAGEMENT",
        value: "E&FM"
    },
    {
        label: "COMPETENCIES AND TRAINING",
        value: "C&T"
    },
    {
        label: "ORGANISATIONAL READINESS",
        value: "OR"
    },
]